import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef, FormEvent, ChangeEvent } from 'react';

import {
  AccionDetalle,
  IInitialState,
  TipoAccionDetalle,
} from '../Shared/data/FormReducer';
import { useMediaQuery } from '@mui/material';
import { sendUserData } from '../Services/Form';

import ToastDisplay from '../Utils/ToastDisplay';
import logo from '../Shared/Images/logo_tr4iner.png';

import './Styles/Login.css';

interface Props {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const Login = ({ state, dispatch }: Props) => {
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [isCheckedState, setIsCheckedState] = useState<boolean>(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 650px)');
  // const pathname = window.location.pathname;

  const bodyRef = useRef<HTMLBodyElement | null>(null);

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;

    if (bodyRef.current) {
      bodyRef.current.style.background =
        'linear-gradient(to bottom, #9c6c06 0%, #000000 23%)';
    }

    return () => {
      if (bodyRef.current) {
        bodyRef.current.style.background = '';
      }
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('user')) {
      navigate('/');
    }
  }, []);

  function isChecked(ev: ChangeEvent<HTMLInputElement>) {
    setIsCheckedState(ev.target.checked);
  }

  function sendData(ev: FormEvent) {
    ev.preventDefault();
    if (user && password) {
      if (!isCheckedState) {
        return toast.error(
          'Debes aceptar los Términos y condiciones y Política de privacidad para poder continuar',
        );
      }
      sendUserData({ Correo: user, Clave: password }).then((response) => {
        if (response.data.status === 200) {
          toast.success(<ToastDisplay title="Sesión iniciada" message="" />);
          dispatch({
            type: TipoAccionDetalle.CHANGE_OBJETIVO,
            payload: response.data.data.objetivo,
          });
          dispatch({
            type: TipoAccionDetalle.CHANGE_NFORM,
            payload: 0,
          });
          dispatch({
            type: TipoAccionDetalle.CHANGE_RESPONDIO,
            payload: response.data.data.respondio,
          });
          dispatch({
            type: TipoAccionDetalle.CHANGE_NOMBRE,
            payload: response.data.data.nombres,
          });
          dispatch({
            type: TipoAccionDetalle.CHANGE_CORREO,
            payload: response.data.data.correo,
          });
          dispatch({
            type: TipoAccionDetalle.CHANGE_USUARIOTESTASESORIAID,
            payload: response.data.data.usuarioTestAsesoriaID,
          });
          const responseData = { ...response.data.data, clave: password };
          localStorage.setItem('user', JSON.stringify(responseData));
          navigate('/');
        } else {
          return toast.error(
            <ToastDisplay
              title="Usuario no encontrado"
              message="Por favor revisa los campos rellenados"
            />,
          );
        }
      });
    } else {
      return toast.error(
        <ToastDisplay title="Completa los campos por favor" message="" />,
      );
    }
  }

  return (
    <div className="login-page">
      {/* Aurora orbs */}
      <div className="login-orb" />
      <div className="login-grain" />

      <div className="login-content">
        {/* Logo */}
        <div className="login-logo">
          <img src={logo} alt="TR4INER" />
        </div>

        {/* Glass Card */}
        <div className="login-card">
          <div className="login-title-section">
            <span className="login-welcome">Bienvenido</span>
            <h1 className="login-title">Inicia Sesión</h1>
            <p className="login-subtitle">Tu transformación comienza aquí</p>
          </div>

          <form onSubmit={sendData}>
            <div className="login-fields">
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                <input
                  type="email"
                  className="login-input"
                  placeholder="Email"
                  autoComplete="email"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                />
              </div>
              <div className="login-input-wrap">
                <span className="login-input-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <input
                  type="password"
                  className="login-input"
                  placeholder="Contraseña"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <button className="login-submit" type="submit">
              Acceder
            </button>

            <label className="login-checkbox-wrap">
              <input
                type="checkbox"
                className="login-checkbox"
                onChange={(ev) => setIsCheckedState(ev.target.checked)}
              />
              <span className="login-checkbox-text">
                He leído y acepto los{' '}
                <a href="https://tr4iner.com/terminos-y-condiciones/" target="_blank" rel="noopener noreferrer" className="login-checkbox-link">Términos y condiciones</a> y la{' '}
                <a href="https://tr4iner.com/politica-de-privacidad/" target="_blank" rel="noopener noreferrer" className="login-checkbox-link">Política de privacidad</a>.
              </span>
            </label>
          </form>

          <div className="login-divider">
            <span className="login-divider-line" />
            <span className="login-divider-text">o bien</span>
            <span className="login-divider-line" />
          </div>

          <div className="login-footer">
            <button className="login-forgot" onClick={() => navigate('/recuperarContrasena')}>
              ¿Olvidaste la contraseña?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
